import { ApiService } from "@/api/services/ApiService";
import { msalInstance, msalReady } from "@/lib/msal-config";
import { useAuthStore } from "@/store/AuthStore";

let pending: Promise<void> | null = null;

export async function ensureUserData(): Promise<void> {
  const store = useAuthStore.getState();
  if (store.userResourceId) return;

  if (!pending) {
    pending = fetchAndStoreUserData();
  }
  return pending;
}

async function fetchAndStoreUserData(): Promise<void> {
  try {
    await msalReady;
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No authenticated account found");
    }

    const upn = accounts[0].username;
    const user = await ApiService.user.getUser(upn);
    const store = useAuthStore.getState();
    store.setUserResourceId(user.bookableResourceId);
    store.setUserSystemId(user.systemUserId);
    store.setUserName(user.fullName);
    store.setUserEmail(user.internalEmailAddress);
  } finally {
    pending = null;
  }
}
